const errorMapping: Record<string, string> = {
  '0': 'errorActionIsNotExecuted',
  '1': 'notificationsItemNotAdded',
  '2': 'notificationsNotEnoughStockItem',
  '3': 'notificationsInvalidResetPasswordUrl',
  '4': 'notificationsCheckPassword',
  '5': 'notificationsItemBundleSplitted',
  '6': 'notificationsItemOutOfStock',
  '7': 'newsletterOptOutSuccessMessage',
  '8': 'newsletterOptInMessage',
  '9': 'notificationsBasketItemsRemoved',
  '10': 'notificationsBasketItemsRemovedForLanguage',
  '11': 'notificationsNoEmailEntered',
  '12': 'notificationsWarningOverselling',
  '13': 'consentReCaptchaCookieNotSet',
  '14': 'notificationsBasketItemsRemovedForCurrency',
  '15': 'notificationsBasketItemsRemovedForShippingCountry',
  '16': 'notificationsBasketItemsRemovedForContactClass',
  '110': 'errorBasketItemVariationNotFound',
  '111': 'errorBasketItemNotEnoughStockForVariation',
  '112': 'errorBasketItemMaximumQuantityReachedForItem',
  '113': 'errorBasketItemMaximumQuantityReachedForVariation',
  '114': 'errorBasketItemMinimumQuantityNotReachedForVariation',
  '115': 'errorCreateOrderRetryTimeNotReached',
  '210': 'errorVatService',
  '211': 'errorVatNumberValidation',
  '212': 'errorVatServiceFallback',
  '301': 'notificationRemoveCouponMinimumOrderValueIsNotReached',
  '401': 'notificationsCalculateShippingFailed',
  '502': 'errorGiftCardReturnQuantity',
  '1018': 'couponMinOrderValueNotReached',
  '1070': 'couponAlreadyUsedOrInvalidCouponCode',
  '1078': 'couponCampaignExpired',
  '1332': 'couponExpired',
  '1400': 'csrfTokenMismatch',
  '1401': 'accessKeyMailSent',
  '1402': 'accessKeyMailFailed',
};

export const getErrorCode = (code: string): string | undefined => {
  return errorMapping[code];
};

export const errorHasKeyValue = (error: unknown, key: string, value: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as Record<string, unknown>)[key] === value;

export const errorHasKeyAnyValue = (error: unknown, key: string, values: unknown[]): boolean =>
  typeof error === 'object' && error !== null && values.includes((error as Record<string, unknown>)[key]);
